module.exports = __webpack_public_path__ + "static/media/term-notes.837d6515.png";